module.exports = __webpack_public_path__ + "img/sindrome_sinais_sintomas.d4643d10.jpg";